import { Link } from "react-router-dom";

interface TVShow {
  id: number;
  title: string;
  titleEn: string;
  category: string;
  year: number;
  rating: number;
  image: string;
  description: string;
  actors: string[];
  episodes: number;
  status: string;
}

interface TVShowCardProps {
  show: TVShow;
}

const categoryNames: Record<string, string> = {
  xuanyi: "悬疑",
  dongzuo: "动作",
  aiqing: "爱情",
  kehuan: "科幻",
  xiju: "喜剧",
  kongbu: "恐怖",
};

export default function TVShowCard({ show }: TVShowCardProps) {
  return (
    <Link
      to={`/article/${show.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300"
    >
      <div className="relative overflow-hidden aspect-[4/3]">
        <img
          src={show.image}
          alt={`${show.title} - ${show.titleEn}`}
          title={`红桃影视大全 - ${show.title} ${show.titleEn}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3 flex items-center gap-2">
          <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md">
            {categoryNames[show.category] || show.category}
          </span>
          <span className="px-2 py-0.5 bg-foreground-900/70 text-background-50 text-xs font-medium rounded-md">
            {show.year}
          </span>
        </div>
        <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-bold rounded-md">
          <i className="ri-star-fill text-[10px]"></i>
          {show.rating}
        </div>
        {show.status === "连载中" && (
          <div className="absolute bottom-3 right-3 px-2 py-0.5 bg-secondary-500 text-background-50 text-xs font-medium rounded-md">
            {show.status}
          </div>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base group-hover:text-primary-500 transition-colors">
          {show.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{show.titleEn}</p>
        <p className="text-xs text-foreground-400 mt-2 line-clamp-2 leading-relaxed">
          {show.description.slice(0, 60)}...
        </p>
        <div className="flex items-center gap-4 mt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-film-line"></i>
            {show.episodes}集
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {show.actors[0]}
          </span>
        </div>
      </div>
    </Link>
  );
}